<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :refresh-table="getData"
      :customTopActions="true"
      item-key="id"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer />
          <v-btn
            color="primary"
            class="mb-2 rounded-pill elevation-0"
            @click="openAddDialog"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah Provider
          </v-btn>
          <v-btn
            icon
            color="warning"
            class="mb-2 ml-2"
            @click="getData"
            :loading="loading"
            :disabled="loading"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:status="{ item }">
        <v-chip
          v-if="merchantCount(item) > 0"
          small
          color="green lighten-4"
          text-color="green darken-3"
        >
          {{ merchantCount(item) }} Merchant
        </v-chip>
        <v-chip
          v-else
          small
          color="grey lighten-3"
          text-color="grey darken-2"
        >
          Belum Ada
        </v-chip>
      </template>

      <template v-slot:action="{ item }">
        <td class="d-block d-sm-table-cell d-print-table-cell text-center">
          <div class="d-inline-flex align-center" style="gap: 12px;">
            <v-icon small color="grey darken-2" @click="openEditDialog(item)">
              mdi-pencil
            </v-icon>
            <v-icon small color="grey darken-2" @click="openDeleteDialog(item)">
              mdi-delete
            </v-icon>
          </div>
        </td>
      </template>
    </TableView>

    <v-dialog v-model="dialog" max-width="640" persistent scrollable>
      <ChannelProviderForm
        :title="dialogTitle"
        :open="dialog"
        :edited-item="editedItem"
        :loading="formLoading"
        :errors="formErrors"
        @save="saveProvider"
        @cancel="closeDialog"
      />
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500" persistent>
      <ChannelProviderDeleteDialog
        v-if="deleteTarget"
        :provider-name="deleteTarget.provider_name"
        :merchant-count="merchantCount(deleteTarget)"
        :loading="deleting"
        @confirm="confirmDelete"
        @cancel="closeDeleteDialog"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import channelProviderMixin from '@components/master-data/channel-provider/channelProviderMixin';

export default {
  mixins: [channelProviderMixin],
  components: {
    TableView: () => import('@components/@drontVue/components/Table/TableView.vue'),
    ChannelProviderForm: () => import('@components/master-data/channel-provider/ChannelProviderForm.vue'),
    ChannelProviderDeleteDialog: () => import('@components/master-data/channel-provider/ChannelProviderDeleteDialog.vue'),
  },
};
</script>
